import H1 from './H1.vue';
import H2 from './H2.vue';
import H3 from './H3.vue';
import H4 from './H4.vue';
import Text from './Text.vue';
import Link from './Link.vue';
import Fig from './Fig.vue';

export default {
  H1,
  H2,
  H3,
  H4,
  Text,
  Link,
  Fig,
};
